import React, { useContext } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { ROUTES } from '../../constants/routes';
import { userHasFn, SUB_APPS } from '../../utils/rbac';
import SubAppHeaderActions from '../../components/SubAppHeaderActions';

const navClass = ({ isActive }) =>
  `nav-link ${isActive ? 'active fw-semibold' : ''}`;

function RulesViolationLayout() {
  const { user } = useContext(AuthContext);
  const canAdmin = userHasFn(user, SUB_APPS.RULES_VIOLATION, 'admin');
  const canReports = userHasFn(user, SUB_APPS.RULES_VIOLATION, 'reports');

  return (
    <div className="container-fluid mt-3 px-3 app-shell-page sub-app-white-nav">
      <div className="app-layout-bar d-flex flex-wrap justify-content-between align-items-center gap-2">
        <h1 className="app-layout-title mb-0">Rules Violation</h1>
        <SubAppHeaderActions
          subAppHomePath={ROUTES.RULES_VIOLATION}
          subAppHomeLabel="Rules Violation"
          navButtonClassName="btn btn-sm bg-white text-dark border"
        />
      </div>

      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <NavLink to={ROUTES.RULES_VIOLATION} end className={navClass}>
            Report violation
          </NavLink>
        </li>
        {canReports && (
          <li className="nav-item">
            <NavLink to={ROUTES.RULES_VIOLATION_REPORTS} className={navClass}>
              Reports
            </NavLink>
          </li>
        )}
        {canAdmin && (
          <li className="nav-item">
            <NavLink to={ROUTES.RULES_VIOLATION_ADMIN} className={navClass}>
              Admin
            </NavLink>
          </li>
        )}
      </ul>

      <Outlet />
    </div>
  );
}

export default RulesViolationLayout;
